/**
 * Product Configuration Queries/Mutations
 */
import gql from 'graphql-tag';
import { ImageFields } from '../../common-fields.queries';

/**
 * Product Resource
 */
export const ProductResourceFields = gql`
	fragment ProductResourceFields on ProductResource {
		title
		brandName
		modelNumber
		url
		status
		quantity
		variantId
		finishes {
			... on ProductVariantCard {
				id
				brandName
				title
				image {
					...ImageFields
				}
				modelNumber
				price
				status
				ratingValue
				reviewCount
				url
				count
			}
		}
		rating {
			reviewCount
			ratingValue
		}
		price {
			current
		}
	}
	${ImageFields}
`;

/**
 * Product Option
 */
export const ProductOptionFields = gql`
	fragment ProductOptionFields on ProductOption {
		type
		name
		value
		selected
		hasPricedOptions
		resource {
			...ProductResourceFields
		}
		image {
			...ImageFields
		}
		slotId
	}
	${ImageFields}
	${ProductResourceFields}
`;

export const ProductOptionHelpFields = gql`
	fragment ProductOptionHelpFields on ProductOptionGroupHelp {
		title
		description
		image {
			...ImageFields
		}
	}
	${ImageFields}
`;

/**
 * Product Configuration Option Fields
 */
export const ProductOptionGroupFields = gql`
	fragment ProductOptionGroupFields on ProductOptionGroup {
		label
		type
		selectionType
		help {
			...ProductOptionHelpFields
		}
		options {
			...ProductOptionFields
		}
		source
	}
	${ProductOptionHelpFields}
	${ProductOptionFields}
`;

/**
 * Get Product Configuration Query
 */
export const GET_PRODUCT_CONFIGURATION = gql`
	query GetProductConfiguration($input: GetProductConfigurationInput!) {
		getProductConfiguration(input: $input) {
			required {
				...ProductOptionGroupFields
			}
		}
	}
	${ProductOptionGroupFields}
`;

export const GET_RECOMMENDED_PRODUCTS = gql`
	query GetRecommendedProducts($input: GetProductConfigurationInput!) {
		getProductConfiguration(input: $input) {
			recommended {
				...ProductOptionGroupFields
			}
		}
	}
	${ProductOptionGroupFields}
`;
